<template>
    <div class="chime-datepicker-wrapper chime-year-picker">
        <div class="chime-datepicker-header line">
            <i
                class="datepicker-btn prev-prev-btn iconfont icon-more_arrow"
                @click="last10Year"
            ></i>
            <p class="title">{{ yearStart }} - {{ yearStart + 9 }}</p>
            <i
                class="datepicker-btn next-next-btn iconfont icon-more_arrow"
                @click="next10Year"
            ></i>
        </div>
        <div class="chime-datepicker-table">
            <table class="year-table" cellpadding="0" cellspacing="0">
                <tbody>
                    <tr v-for="(yearGroup, idx1) in years" :key="idx1">
                        <td
                            v-for="(year, idx2) in yearGroup"
                            :key="idx2"
                            @click="chooseYear(year)"
                        >
                            <div>{{ year }}</div>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>
<script>
export default {
    emits: ['chooseYear'],
    name: 'MonthPicker',
    props: {
        year: {
            type: Number
        }
    },
    data: function() {
        let defaultYearStart = Math.floor(new Date().getFullYear() / 10) * 10;
        return {
            yearStart: defaultYearStart
        };
    },
    computed: {
        years() {
            let ys = this.yearStart;
            return [
                [ys++, ys++, ys++, ys++],
                [ys++, ys++, ys++, ys++],
                [ys++, ys++]
            ];
        }
    },
    methods: {
        last10Year() {
            this.yearStart -= 10;
        },
        next10Year() {
            this.yearStart += 10;
        },
        chooseYear(year) {
            this.$emit('chooseYear', year);
        }
    }
};
</script>
<style lang="scss">
.chime-datepicker-wrapper {
    .chime-datepicker-table {
        .year-table {
            td div {
                height: 48px;
                line-height: 36px;
                padding: 6px 0;
                box-sizing: border-box;
            }
        }
    }
}
</style>
